"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var sis_control_with_settings_1 = require("../../sis-control-with-settings");
var sis_dynamic_multiselect_settings_component_1 = require("./sis-dynamic-multiselect-settings.component");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
require("./sis-dynamic-multiselect.component.scss");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var SisDynamicMultiselectComponent = /** @class */ (function (_super) {
    __extends(SisDynamicMultiselectComponent, _super);
    function SisDynamicMultiselectComponent(_classifierService, _currentLanguageProvider, _kbService) {
        var _this = _super.call(this) || this;
        _this._classifierService = _classifierService;
        _this._currentLanguageProvider = _currentLanguageProvider;
        _this._kbService = _kbService;
        _this.destroySubject$ = new Subject_1.Subject();
        _this.dataItemsSubject$ = new ReplaySubject_1.ReplaySubject(1);
        _this._nameMetaFieldIdsSubject = new ReplaySubject_1.ReplaySubject(1);
        _this._nameField = 'name';
        _this._valueField = 'id';
        return _this;
    }
    Object.defineProperty(SisDynamicMultiselectComponent.prototype, "nameField", {
        get: function () {
            return this._nameField;
        },
        set: function (value) {
            if (value !== 'name') {
                throw new Error("nameField should be 'name'");
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicMultiselectComponent.prototype, "valueField", {
        get: function () {
            return this._valueField;
        },
        set: function (value) {
            if (value !== 'id') {
                throw new Error("nameField should be 'id'");
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicMultiselectComponent.prototype, "isReadonly", {
        get: function () {
            return this._isReadonly;
        },
        set: function (value) {
            this._isReadonly = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicMultiselectComponent.prototype, "classifierViews", {
        set: function (value) {
            if (!this._dataItems || this._dataItems.length === 0) {
                this._dataItems = value ? this.convertToDataItems(value) : [];
            }
            else if (value) {
                this.addDataItems.apply(this, this.convertToDataItems(value));
            }
            if (value) {
                this.dataItemsSubject$.next(this._dataItems);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicMultiselectComponent.prototype, "dataItems", {
        get: function () {
            return this._dataItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicMultiselectComponent.prototype, "selectedClassifiers", {
        set: function (values) {
            this._selectedClassifiers = values ? values : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicMultiselectComponent.prototype, "nameMetaFieldIds", {
        get: function () {
            return this._nameMetaFieldIds;
        },
        set: function (value) {
            this._nameMetaFieldIds = value ? value : [];
            if (value) {
                this._nameMetaFieldIdsSubject.next(this._nameMetaFieldIds);
            }
        },
        enumerable: true,
        configurable: true
    });
    SisDynamicMultiselectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isReady$ = combineLatest_1.combineLatest(this.dataItemsSubject$, this._nameMetaFieldIdsSubject, this._currentLanguageProvider.getCurrentLanguage()).pipe(operators_1.map(function (data) {
            _this._selectedClassifiers
                .filter(function (classifier) {
                return _this._dataItems.every(function (dataItem) {
                    return dataItem.id !== classifier.getId();
                });
            })
                .forEach(function (classifier) {
                var name = _this._nameMetaFieldIds
                    .map(function (nameMetaFieldId) {
                    var value = classifier.getProperty(nameMetaFieldId.getSystemName()).value;
                    if (value instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
                        return value.getValue(data[2].getId());
                    }
                    return value;
                })
                    .join('/');
                _this.addDataItems({
                    id: classifier.getId(),
                    name: name,
                    isEnabled: false,
                });
            });
            return true;
        }), operators_1.takeUntil(this.destroySubject$));
    };
    SisDynamicMultiselectComponent.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    SisDynamicMultiselectComponent.prototype.convertToIds = function () {
        return this.entity
            ? this.entity
                .getProperty(this.fieldSystemName)
                .value.map(function (item) { return item.getId(); })
            : [];
    };
    SisDynamicMultiselectComponent.prototype.convertToClassifiers = function (values) {
        var _this = this;
        if (values.length === 0) {
            this.entity.getProperty(this.fieldSystemName).value = [];
        }
        else {
            this._classifierService
                .loadClassifiersByIds(this.categoryName, values)
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (data) {
                _this._selectedClassifiers = data.getData();
                _this.entity.getProperty(_this.fieldSystemName).value = data.getData();
            }, function (err) { return console.error(err); });
        }
    };
    SisDynamicMultiselectComponent.prototype.convertToDataItems = function (classifierViews) {
        return classifierViews.map(function (classifierView) { return ({
            id: classifierView.getId(),
            name: classifierView.getName(),
            isEnabled: true,
        }); });
    };
    SisDynamicMultiselectComponent.prototype.addDataItems = function () {
        var _this = this;
        var dataItems = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            dataItems[_i] = arguments[_i];
        }
        dataItems.forEach(function (dataItem) {
            if (_this._dataItems.findIndex(function (item) { return item.id === dataItem.id; }) === -1) {
                _this._dataItems.push(dataItem);
            }
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicMultiselectComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], SisDynamicMultiselectComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicMultiselectComponent.prototype, "fieldSystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicMultiselectComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisDynamicMultiselectComponent.prototype, "nameField", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisDynamicMultiselectComponent.prototype, "valueField", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SisDynamicMultiselectComponent.prototype, "isReadonly", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], SisDynamicMultiselectComponent.prototype, "classifierViews", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], SisDynamicMultiselectComponent.prototype, "selectedClassifiers", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], SisDynamicMultiselectComponent.prototype, "nameMetaFieldIds", null);
    SisDynamicMultiselectComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-dynamic-multiselect',
            template: require('./sis-dynamic-multiselect.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Dynamic Multiselect',
            settings: {
                main: sis_dynamic_multiselect_settings_component_1.SisDynamicMultiSelectSettingsComponent,
            },
            template: "\n                        <sis-dynamic-multiselect [id]=\"'%{id}'\" [entity]=\"contextEntity\"\n                            [categoryName]=\"'%{field-category}'\" [hint]=\"%{hint}\" [fieldSystemName]=\"'%{field-name}'\"\n                            [classifierViews]=\"%{dataItems}\" [selectedClassifiers]=\"%{field}\"\n                            [nameMetaFieldIds]=\"%{nameMetaFieldIds}\" [nameField]=\"'name'\" [valueField]=\"'id'\"\n                            [isReadonly]=\"%{isReadonly}\">\n                        </sis-dynamic-multiselect>\n                      ",
            iconInfo: 'fa-list-alt',
            isFieldBound: true,
            defaultActions: {
                dataItems: 'loadClassifiers-async',
                nameMetaFieldIds: 'getNameMetaFieldIds-async',
            },
        }),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_kb_service_client_js_1.KbService])
    ], SisDynamicMultiselectComponent);
    return SisDynamicMultiselectComponent;
}(sis_control_with_settings_1.SisControlWithSettings));
exports.SisDynamicMultiselectComponent = SisDynamicMultiselectComponent;
//# sourceMappingURL=sis-dynamic-multiselect.component.js.map